import { getStyled } from './styles';

const MainHeader = ({ children }) => {
  const classes = getStyled();

  return <div style={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
